var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6942be83036482c021184a904cd5354cd5245194"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// The full client SDK loads only after the first captured error. A tiny local
// bridge preserves early errors and user context without taxing healthy pages.
// RUM's independent early script remains unchanged.

import {
  activateDeferredSentryClient,
  captureDeferredSentryException,
  registerDeferredSentryLoader,
} from '@/utils/deferredSentry'

if (typeof window !== 'undefined') {
  const captureEarlyError = (event: ErrorEvent): void => {
    captureDeferredSentryException(event.error ?? new Error(event.message))
  }
  const captureEarlyRejection = (event: PromiseRejectionEvent): void => {
    captureDeferredSentryException(event.reason)
  }

  window.addEventListener('error', captureEarlyError)
  window.addEventListener('unhandledrejection', captureEarlyRejection)

  const initializeSentry = async (): Promise<void> => {
    const Sentry = await import('@sentry/nextjs')
    Sentry.init({
      dsn: 'https://bc3e26bbcf41d7606c88e0421f270ead@o4504087099408384.ingest.us.sentry.io/4507090994659328',
      tracesSampleRate: 0,
      debug: false,
    })
    activateDeferredSentryClient(Sentry)

    window.removeEventListener('error', captureEarlyError)
    window.removeEventListener('unhandledrejection', captureEarlyRejection)
  }

  registerDeferredSentryLoader(initializeSentry)
}
